<template>
    <div class="roma-page-content fill-height">
        <v-container class="form-new-activity">
            <!-- Label -->
            <v-row class="align-center justify-space-between">
                <v-col cols="auto">
                    <h2 class="form-new-activity__title d-flex align-center">
                        <v-icon>icon-create-activity</v-icon>
                        <span class="ml-2">Actividad</span>
                    </h2>
                </v-col>
                <v-col cols="auto" class="d-flex justify-end">
                    <v-btn
                        color="white"
                        fab
                        class="close-btn"
                        @click="goBack()"
                        small
                    >
                        <img src="@/assets/images/close.svg" alt="" />
                        <!-- <v-icon color="red">mdi-close</v-icon> -->
                    </v-btn>
                </v-col>
            </v-row>

            <!-- code title activity-type -->
            <v-row>
                <v-col cols="4">
                    <v-text-field
                        dense
                        v-model="code"
                        :rules="requiredRules"
                        name="code"
                        label="Código"
                        outlined
                        rounded
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field
                        dense
                        v-model="title"
                        :rules="requiredRules"
                        name="title"
                        label="Título"
                        outlined
                        rounded
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-select
                        dense
                        v-model="activity"
                        :items="getActivitiesTypes"
                        :item-text="item => item.name"
                        :item-value="item => item.activityTypeId"
                        label="Tipo de actividad"
                        outlined
                        rounded
                        :rules="requiredRules"
                        disabled
                    ></v-select>
                </v-col>
            </v-row>

            <div class="no-edit">
                <RomaDynamicResource
                    :data="setDynamicResourceContent"
                    :content="dynamicResourceContent"
                    :resourcesTO="getActivity.resourcesTO"
                    :disabled="true"
                />
            </div>

            <!-- Tutorial -->
            <v-row no-gutters="">
                <v-col class="d-flex align-center">
                    <h3>
                        <!-- <v-icon>icon-instructions</v-icon> -->
                        <span class="mx-4">Instructivos</span>
                    </h3>
                    <v-checkbox
                        v-model="instructions"
                        :value="instructions"
                        disabled
                    ></v-checkbox>
                </v-col>
            </v-row>

            <v-row v-if="instructions">
                <v-col class="no-edit">
                    <TipTap
                        placeholder="Instructivo"
                        :data="setInstruction"
                        :updateMode="{
                            status: true,
                            currentSelected: this.instructionsContent
                        }"
                    />
                </v-col>
            </v-row>

            <!-- task by student -->
            <!-- <v-row class="mt-3">
            <v-col cols="4" class="mt-2 no-padding col-29">
                <h3 class="font-weight-regular">
                <v-icon>icon-create-activity</v-icon>
                <span class="ml-8 title-check">Recibir tareas del estudiante</span>
                </h3>
            </v-col>
            <v-col class="no-padding" cols="1">
                <v-checkbox v-model="receive" :value="receive" class="mb-3"></v-checkbox>
            </v-col>
            <v-col cols="4" sm="4" md="4" class="no-padding" v-if="receive">
                <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                min-width="290px"
                >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        dense
                    v-model="date"
                    label="Desde"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
                </v-menu>
            </v-col>
        </v-row> -->

            <!-- Shared with Students -->
            <v-row class="custom-checkbox-wrapper">
                <v-col cols="auto" offset="1">
                    <v-checkbox
                        class="subtitle-label"
                        v-model="sharedAll"
                        label="Compartir con todos"
                        :value="sharedAll"
                        disabled
                    ></v-checkbox>
                </v-col>
                <v-col cols="auto">
                    <v-checkbox
                        class="subtitle-label"
                        v-model="sharedSome"
                        label="Compartir con algunos estudiantes"
                        :value="sharedSome"
                        disabled
                    ></v-checkbox>
                </v-col>
            </v-row>

            <v-row v-if="sharedSome" class="fixed-height">
                <v-col cols="12">
                    <v-select
                        v-model="student"
                        :items="students"
                        :item-text="item => getfullName(item)"
                        label="Selecciona los estudiantes"
                        outlined
                        rounded
                        multiple
                        chips
                        :rules="requiredRules"
                        disabled
                    ></v-select>
                </v-col>
            </v-row>

            <!-- pruebas Frederick -->
            <!-- <v-row>
            <v-radio-group
                v-model="radioGroup"
                :column="false"
                class="shared-radios"
            >
                <v-radio label="Compartir con todos" :value="1"></v-radio>
                <v-radio
                    class="ml-5"
                    label="Compartir con algunos estudiantes"
                    :value="2"
                ></v-radio>
            </v-radio-group>
        </v-row> -->

            <!-- save form -->
            <!-- :disabled="!availableSubmit" -->
            <!-- <v-row class="justify-center">
                <v-btn
                    rounded
                    color="accent"
                    large
                    :disabled="false"
                    class="roma-btn"
                    @click="createOrUpdate()"
                >
                    <span class="text-capitalize mr-4">Guardar</span>
                    <v-icon>icon-save-white</v-icon>
                </v-btn>
            </v-row> -->
        </v-container>
    </div>
</template>

<script>
import TipTap from "@/components/commons/RomaTipTap.vue";
import RomaDynamicResource from "@/components/commons/RomaDynamicResource";
import { mapActions, mapGetters } from "vuex";

export default {
    props: {
        activityId: {
            default: null
        }
    },
    name: "RomaFormNewActivity",
    data() {
        return {
            radioGroup: 1,
            date: new Date().toISOString().substr(0, 10),
            sharedAll: true,
            sharedSome: false,
            instructions: false,
            editorIsEmpty: false,
            activity: "",
            code: "",
            title: "",
            type: "",
            resource: "",
            description: "",
            instructionsContent: "",
            student: "",
            activities: ["Tipo 1", "Tipo 2", "Tipo 3", "Tipo 4"],
            students: [
                {
                    id: 1,
                    firstName: "abc",
                    middleName: "abc",
                    motherLastName: "xyz",
                    fatherLastName: "xyz"
                },
                {
                    id: 2,
                    firstName: "luis",
                    middleName: "asd",
                    motherLastName: "qwe",
                    fatherLastName: "qwe"
                },
                {
                    id: 3,
                    firstName: "qwe",
                    middleName: "asd",
                    motherLastName: "rty",
                    fatherLastName: "xcv"
                }
            ],
            requiredRules: [v => !!v || "Este campo es requerido"],
            dynamicResourceContent: "",
            lessonId: this.$route.params.id
        };
    },
    mounted() {
        // this.getInfoByLessonId(this.lessonId)
        //     .then(() => {
        //         this.destructuringStudentName();
        //     })
        //     .catch(e => {
        //         console.info("error", e);
        //     });

        console.log(this.$route);

        this.activityId
            ? this.actionGetActivity(this.activityId)
            : this.actionResetActivity();
        this.actionGetActivitiesTypes();

        this.activityId ? this.actionGetActivity(this.activityId) : "";

        setTimeout(() => {
            this.$route.params.id ? this.updateMode(this.getActivity) : false;
        }, 2000);
    },
    destroyed() {
        this.actionResetResources();
    },
    components: {
        TipTap,
        RomaDynamicResource
    },
    computed: {
        availableSubmit() {
            const availableSubmit =
                !!this.title &&
                !!this.code &&
                !!this.activity &&
                !!this.dynamicResourceContent.length;
            return availableSubmit;
        },
        ...mapGetters({
            getActivitiesInfo: "getActivitiesInfo",
            getActivitiesTypes: "getActivitiesTypes",
            getResources: "getResources",
            getActivity: "getActivity",
            getLesson: "getLesson"
        })
    },
    watch: {
        sharedSome() {
            this.sharedAll = !this.sharedAll;
        }
    },
    methods: {
        ...mapActions({
            toastSuccess: "toastSuccess",
            toastError: "toastError",
            addNewActivity: "addNewActivity",
            actionUpdateActivity: "actionUpdateActivity",
            getInfoByLessonId: "getInfoByLessonId",
            actionGetActivitiesTypes: "actionGetActivitiesTypes",
            actionGetActivity: "actionGetActivity",
            actionResetActivity: "actionResetActivity",
            actionResetResources: "actionResetResources"
        }),
        destructuringStudentName() {
            const { students } = this.getActivitiesInfo;
            const array = [];
            students.forEach(student => {
                array.push({
                    firstName: this.capitalizeFirstLetter(
                        student.fullName.split(" ")[2].toLowerCase()
                    ),
                    middleName: this.capitalizeFirstLetter(
                        student.fullName.split(" ")[3].toLowerCase()
                    ),
                    motherLastName: this.capitalizeFirstLetter(
                        student.fullName.split(" ")[1].toLowerCase()
                    ),
                    fatherLastName: this.capitalizeFirstLetter(
                        student.fullName.split(" ")[0].toLowerCase()
                    )
                });
            });
            this.students = array;
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleSharedAll() {
            this.sharedAll = !this.sharedAll;
        },
        toggleSharedSome() {
            this.sharedSome = this.sharedSome && this.sharedAll ? false : true;
        },
        setDynamicResourceContent(data) {
            this.dynamicResourceContent = data;
        },
        getfullName(fullname) {
            if (
                fullname.motherLastName == fullname.fatherLastName &&
                fullname.firstName == fullname.middleName
            ) {
                return `${fullname.firstName} ${fullname.fatherLastName} ${fullname.motherLastName[0]}.`;
            } else if (fullname.motherLastName == fullname.fatherLastName) {
                return `${fullname.firstName} ${fullname.middleName[0]}. ${fullname.fatherLastName}`;
            } else {
                return `${fullname.firstName} ${fullname.fatherLastName}`;
            }
        },
        setDescription(description) {
            this.description = description;
        },
        setInstruction(instructions) {
            this.instructionsContent = instructions;
        },
        isEmpty() {
            console.info(!!this.description);
            this.editorIsEmpty = !!(
                (this.description === "") |
                (this.description === "<p></p>")
            );
        },
        createNewActivity() {
            const recursos = [];

            this.getResources.forEach(element => {
                const resourceTypeId = element.data.resourceTypeId;
                let link = null;
                let fileName = null;
                let path = null;
                let description = null;

                switch (resourceTypeId) {
                    // Archivo
                    case 1:
                        fileName = element.content[0].name;
                        path = null;
                        break;

                    // Enlace Externo
                    case 2:
                        link = element.content;
                        break;

                    // Video Enlace
                    case 3:
                        link = element.content;
                        break;

                    // Texto Enriquecido
                    case 4:
                        description = element.content;
                        break;

                    default:
                        break;
                }

                recursos.push({
                    resourceTypeId,
                    link,
                    fileName,
                    path,
                    description
                });
            });

            console.log(recursos);

            const form = new FormData();

            form.append("code", this.code);
            form.append("title", this.title);
            form.append("instructive", this.instructionsContent);
            form.append("lessonId", this.activityId);
            form.append("activityTypeId", this.activity);
            form.append("resources", this.getResources);
            form.append(
                "sharedStudents",
                this.sharedSome ? this.student : false
            );
            form.append("sharedAll", this.sharedAll);

            const newActivity = {
                code: this.code,
                title: this.title,
                instructive: this.instructionsContent,
                // state:,
                // editState:,
                // deadline:,
                lessonId: this.getLesson.lessonId,
                activityTypeId: this.activity,
                // personId:,
                // isAllStudents:,
                // studentsId:,
                resources: recursos,
                // instructions: this.instructionsContent,
                sharedStudents: this.sharedSome ? this.student : false,
                sharedAll: this.sharedAll
            };
            console.info("--Nueva Actividad--", newActivity);

            this.addNewActivity(newActivity)
                .then(() => {
                    this.toastSuccess({
                        message: `Se creo la Actividad "${this.code} ${this.title}"`
                    });
                    this.goBack();
                })
                .catch(err => {
                    console.info("error", err);
                });
        },
        updateActivity() {
            console.log("### ACTUALIZAR ACTIVIDAD ###");

            const recursos = [];

            this.getResources.forEach(element => {
                const resourceTypeId = element.data.resourceTypeId;
                let link = null;
                let fileName = null;
                let path = null;
                let description = null;

                switch (resourceTypeId) {
                    // Archivo
                    case 1:
                        fileName = element.content[0].name;
                        path = null;
                        break;

                    // Enlace Externo
                    case 2:
                        link = element.content;
                        break;

                    // Video Enlace
                    case 3:
                        link = element.content;
                        break;

                    // Texto Enriquecido
                    case 4:
                        description = element.content;
                        break;

                    default:
                        break;
                }

                recursos.push({
                    resourceTypeId,
                    link,
                    fileName,
                    path,
                    description
                });
            });

            const activity = {
                activityId: this.activityId,
                code: this.code,
                title: this.title,
                instructive: this.instructionsContent,
                // state:,
                // editState:,
                // deadline:,
                lessonId: this.getLesson.lessonId,
                activityTypeId: this.activity,
                // personId:,
                // isAllStudents:,
                // studentsId:,
                resources: recursos,
                // instructions: this.instructionsContent,
                sharedStudents: this.sharedSome ? this.student : false,
                sharedAll: this.sharedAll
            };
            console.info("--Actividad--", activity);

            this.actionUpdateActivity(activity)
                .then(() => {
                    this.toastSuccess({
                        message: `Se actualizo la Actividad "${this.code} ${this.title}"`
                    });
                    this.goBack();
                })
                .catch(err => {
                    console.info("error", err);
                });
        },
        createOrUpdate() {
            this.$route.params.id
                ? this.updateActivity()
                : this.createNewActivity();
        },
        toggleModal() {
            this.dialog = !this.dialog;
        },
        updateMode(data) {
            if (data) {
                this.code = data.code;
                this.title = data.title;
                this.activity = data.activityTypeTO.activityTypeId;
                this.instructionsContent = data.instructive
                    ? data.instructive
                    : "";
                this.instructions = data.instructive ? true : false;
                this.activityId = data.activityLessonId;
            }
        }
    }
};
</script>

<style lang="scss">
.no-edit {
    opacity: 0.5;
    pointer-events: none;
}
.form-new-activity {
    .shared-radios {
        // background-color: #bada55;
        .v-radio {
            flex-direction: row-reverse;
        }
        .v-input--selection-controls__input {
            margin-left: 1rem;
            // background-color: #bada55;
        }
    }
    &__subtitle {
        font-size: 19px;
    }
    .subtitle-label {
        .v-label {
            font-size: 18px;
        }
    }
    .custom-checkbox-wrapper {
        .v-input {
            &--checkbox {
                .v-input__slot {
                    flex-direction: row-reverse;
                    .v-label {
                        flex: 0 1 max-content;
                        margin-right: 1rem;
                    }
                }
            }
        }
    }
    .fixed-height {
        .v-select__selections {
            min-height: 56px !important;
        }
    }
    @media (min-width: 1904px) {
        &__title {
            font-size: 36px;
        }
    }
    @media (min-width: 1264px) and (max-width: 1903px) {
        &__title {
            font-size: 31px;
        }
    }
    @media (min-width: 960px) and (max-width: 1263px) {
        &__title {
            font-size: 25px;
        }
    }
    @media (min-width: 600px) and (max-width: 959px) {
    }
    @media (max-width: 599px) {
        &__title {
            font-size: 17px;
        }
    }
}
</style>
